import { SET_ACCOUNT_ID_PARAM } from './constants'

export default (state = {}, action) => {
    let newState
    switch (action.type) {
        case SET_ACCOUNT_ID_PARAM:
            {
                const { payload } = action

                newState = { ...state, accountIdParam: payload }
            }
            break
        default:
            newState = state
    }

    return newState
}
